import React from 'react'
import TwoColumnLayout, { ColumnWrapOrder } from 'components/TwoColumnLayout'
import Line from 'components/Line'
import SectionLink from 'components/SectionLink'
import Shadow from 'components/Shadow'
import H3 from 'components/H3'
import SectionBody1 from 'components/SectionBody1'
import StaticImageWrapper from '../components/StaticImageWrapper'
import { StaticImage } from 'gatsby-plugin-image'

const StandoutSection = () => {
    return (
        <TwoColumnLayout leftCol={5} rightCol={6} columnWrapOrderOnMobile={ColumnWrapOrder.NORMAL}>
            <Shadow>
                <StaticImageWrapper
                    placeholder={
                        'https://assets.lune.co/lune-co/placeholders/logistics-exploreprojects-projects.svg'
                    }
                >
                    <StaticImage
                        placeholder={'dominantColor'}
                        src={'../images/OrderConfirmationLogistics.png'}
                        alt={'YourBank'}
                        layout="fullWidth"
                        quality={100}
                    />
                </StaticImageWrapper>
            </Shadow>

            <>
                <H3>Win more customers by making climate action part of your platform</H3>
                <SectionBody1>
                    Up to 2 in 3 shippers choose to create climate action through their shipments —
                    tap into the growing demand by offering high quality carbon offsets to your
                    customers.
                </SectionBody1>

                <Line />

                <SectionLink text={'Explore our projects'} to={'/projects'} />
            </>
        </TwoColumnLayout>
    )
}

export default StandoutSection
